var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('food-search',{attrs:{"type":"Chef","user":_vm.user}}),_c('map-search',{attrs:{"type":"Chef"}}),_c('featured-chefs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }